// Who may open the estimating database tables (labor, tools, materials,
// general conditions...), now tabs of Pricing Catalogs
// (pages/PricingCatelogs/PricingCatalogsWorkspace).
//
// Owner, 2026-10-26: "also gate the estimation databse behind permission
// too" - its own key, estimatingDatabase, not pricingDatabaseView (which gates
// the Catalogs tab). Owner 2026-11-03 kept both keys when the two pages were
// merged. CurLight checks the same key on every call these tables make
// (the X-BidLight-Surface header, curlight utils/estimatingDatabaseGate).
import { ALL_PERMISSIONS } from "constants/permissionsConstants";

export const canOpenEstimatingDatabase = (permissions) =>
  Array.isArray(permissions) &&
  permissions.includes(ALL_PERMISSIONS.ESTIMATING_DATABASE);
